import script from "./ReportPagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportPagination.vue?vue&type=script&setup=true&lang=ts"

import "./ReportPagination.vue?vue&type=style&index=0&id=35ec15ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35ec15ec"]])

export default __exports__